module.exports = __webpack_public_path__ + "static/media/roaring-7s.52da43dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/roaring-7s.png
// module id = 1362
// module chunks = 1